const LightConfluenceBackground = () => {
    return (
        <svg
            viewBox="0 0 1728 1117"
            fill="none"
            style={{
                minWidth: "100%",
                minHeight: "100%",
                position: "absolute"
            }}
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#a)">
                <path fill="#fff" d="M0 0h1728v1117H0z" />
                <path fill="#fff" d="M240 58h1488v1059H240z" />
                <path fill="#fff" d="M240 58h1488v88H240z" />
                <g clipPath="url(#b)">
                    <g clipPath="url(#c)">
                        <rect
                            x="1456"
                            y="86"
                            width="32"
                            height="32"
                            rx="3"
                            fill="#fff"
                            fillOpacity=".01"
                        />
                        <path
                            fill="#fff"
                            fillOpacity=".01"
                            d="M1460 90h24v24h-24z"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M1464.02 109.23c-.03.162-.03.33.02.488.05.158.14.302.25.419.12.117.26.203.42.251.16.048.33.055.49.022l3.81-.78-4.21-4.21-.78 3.81Zm5.92-2.62-2.12-2.12 8.49-8.49 2.12 2.121-8.49 8.49v-.001Zm9.9-9.903-2.12-2.122c-.18-.1859-.4-.3333-.65-.4337-.24-.1004-.5-.1518-.76-.1513-.51 0-1.03.195-1.42.585l-9.75 9.758 4.95 4.95 9.75-9.758c.38-.3751.59-.8837.59-1.414 0-.5303-.21-1.0389-.59-1.414Z"
                            fill="#C1C7D0"
                        />
                        <rect
                            x="1488"
                            y="86"
                            width="32"
                            height="32"
                            rx="3"
                            fill="#fff"
                            fillOpacity=".01"
                        />
                        <path
                            fill="#fff"
                            fillOpacity=".01"
                            d="M1492 90h24v24h-24z"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M1497 101.513c0-3.038 3.14-5.51 7-5.51s7 2.472 7 5.51c0 3.039-3.14 5.51-7 5.51s-7-2.471-7-5.51Zm14.84 7.771v-.002s-1.57-2.26-.77-3.116l-.04.02c1.23-1.284 1.97-2.907 1.97-4.673 0-4.142-4.04-7.513-9-7.513s-9 3.37-9 7.513 4.04 7.514 9 7.514c1.42 0 2.76-.285 3.96-.776 1 1.022 2.28 1.572 3.24 1.719v-.003c.05.02.11.031.16.033.09 0 .17-.021.25-.061.07-.041.14-.099.18-.17.05-.071.08-.152.09-.237 0-.084-.01-.17-.04-.248Z"
                            fill="#C1C7D0"
                        />
                        <path
                            d="M1508 99h-8c-.55 0-1 .4477-1 1 0 .552.45 1 1 1h8c.55 0 1-.448 1-1 0-.5523-.45-1-1-1ZM1503 102h-3c-.55 0-1 .448-1 1s.45 1 1 1h3c.55 0 1-.448 1-1s-.45-1-1-1Z"
                            fill="#C1C7D0"
                        />
                        <rect
                            x="1520"
                            y="86"
                            width="32"
                            height="32"
                            rx="3"
                            fill="#fff"
                            fillOpacity=".01"
                        />
                        <path
                            fill="#fff"
                            fillOpacity=".01"
                            d="M1524 90h24v24h-24z"
                        />
                        <path
                            d="m1536 106.373 3.98 2.193-.76-4.655 3.28-3.347-4.53-.6899-1.97-4.187-1.97 4.189-4.53.6889 3.28 3.345-.76 4.655 3.98-2.192Zm0 2.283-3.02 1.662c-.32.181-.7.266-1.07.245-.38-.02-.74-.146-1.04-.363-.31-.216-.55-.514-.7-.861-.14-.346-.19-.726-.13-1.096l.6-3.656-2.57-2.624c-.25-.263-.43-.592-.52-.951-.08-.359-.06-.733.06-1.0827.11-.3492.32-.6594.61-.8964.28-.237.62-.3917.98-.4468l3.47-.528 1.52-3.224c.16-.3431.42-.6331.74-.8362.32-.2031.69-.3109 1.07-.3109.38 0 .75.1078 1.07.3109.32.2031.58.4931.74.8362l1.52 3.224 3.47.528c.36.0554.7.2103.98.4474.29.2372.5.5474.61.8966.12.3489.14.7239.06 1.0829-.09.358-.27.687-.53.95l-2.56 2.624.59 3.656c.07.371.02.751-.12 1.097-.15.346-.39.645-.7.861-.3.217-.66.342-1.04.363-.37.021-.75-.065-1.08-.246l-3.01-1.662Z"
                            fill="#C1C7D0"
                        />
                        <rect
                            x="1552"
                            y="86"
                            width="32"
                            height="32"
                            rx="3"
                            fill="#fff"
                            fillOpacity=".01"
                        />
                        <path
                            fill="#fff"
                            fillOpacity=".01"
                            d="M1556 90h24v24h-24z"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M1568 108c-4.54 0-8-4.26-8-6 0-2.001 3.46-6 8-6 4.38 0 8 3.973 8 6 0 1.74-3.46 6-8 6Zm0-14c-5.52 0-10 4.841-10 8 0 3.086 4.58 8 10 8s10-4.914 10-8c0-3.159-4.48-8-10-8"
                            fill="#C1C7D0"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M1567.98 103.984c-1.11 0-2-.897-2-2s.89-2 2-2c1.1 0 2 .897 2 2s-.9 2-2 2Zm0-6c-2.21 0-4 1.794-4 4s1.79 4 4 4c2.2 0 4-1.794 4-4s-1.8-4-4-4Z"
                            fill="#C1C7D0"
                        />
                    </g>
                    <rect
                        x="1590"
                        y="86"
                        width="60"
                        height="32"
                        rx="3"
                        fill="#091E42"
                        fillOpacity=".08"
                    />
                    <rect
                        x="1598"
                        y="99"
                        width="44"
                        height="6"
                        rx="3"
                        fill="#091E42"
                        fillOpacity=".13"
                    />
                    <rect
                        x="1656"
                        y="86"
                        width="32"
                        height="32"
                        rx="3"
                        fill="#fff"
                        fillOpacity=".01"
                    />
                    <path
                        fill="#fff"
                        fillOpacity=".01"
                        d="M1660 90h24v24h-24z"
                    />
                    <path
                        d="M1665 104c1.1 0 2-.895 2-2s-.9-2-2-2-2 .895-2 2 .9 2 2 2ZM1672 104c1.1 0 2-.895 2-2s-.9-2-2-2-2 .895-2 2 .9 2 2 2ZM1679 104c1.1 0 2-.895 2-2s-.9-2-2-2-2 .895-2 2 .9 2 2 2Z"
                        fill="#C1C7D0"
                    />
                </g>
                <rect
                    x="604"
                    y="146"
                    width="503"
                    height="20"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <g clipPath="url(#d)">
                    <rect
                        x="648"
                        y="206"
                        width="192"
                        height="6"
                        rx="3"
                        fill="#091E42"
                        fillOpacity=".13"
                    />
                </g>
                <rect
                    x="648"
                    y="194"
                    width="119"
                    height="6"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <circle
                    cx="620"
                    cy="206"
                    r="17"
                    fill="url(#e)"
                    stroke="#fff"
                    strokeWidth="2"
                />
                <rect
                    x="604"
                    y="246"
                    width="760"
                    height="86"
                    rx="5"
                    fill="#DEEBFF"
                />
                <path fill="#fff" fillOpacity=".01" d="M620 262h24v24h-24z" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M632 284c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm1-14c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1Zm-1 2c.552 0 1 .448 1 1v5c0 .552-.448 1-1 1s-1-.448-1-1v-5c0-.552.448-1 1-1Z"
                    fill="#0052CC"
                />
                <rect
                    x="670"
                    y="272"
                    width="659"
                    height="12"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="670"
                    y="294"
                    width="325"
                    height="12"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="604"
                    y="364"
                    width="117"
                    height="20"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="604"
                    y="400"
                    width="98.5"
                    height="20"
                    rx="10"
                    fill="#B3D4FF"
                />
                <path
                    d="M616.624 405.19c-3.35 0-5.646 2.318-5.646 5.702 0 3.493 2.235 5.708 5.762 5.708.862 0 1.689-.123 2.304-.335v-.862c-.431.199-1.354.328-2.29.328-2.926 0-4.813-1.879-4.813-4.798 0-2.844 1.921-4.881 4.594-4.881 2.735 0 4.608 1.688 4.608 4.156 0 1.682-.554 2.769-1.415 2.769-.493 0-.773-.281-.773-.759v-4.013h-1.032v.834h-.11c-.266-.595-.881-.964-1.599-.964-1.402 0-2.379 1.162-2.379 2.823 0 1.737.957 2.906 2.379 2.906.8 0 1.415-.39 1.709-1.087h.109c.082.67.704 1.148 1.504 1.148 1.572 0 2.57-1.415 2.57-3.643 0-2.967-2.249-5.032-5.482-5.032Zm-.239 3.829c.929 0 1.524.738 1.524 1.907s-.601 1.914-1.538 1.914c-.895 0-1.442-.725-1.442-1.914 0-1.197.54-1.907 1.456-1.907Z"
                    fill="#091E42"
                    fillOpacity=".48"
                />
                <rect
                    x="625.5"
                    y="407"
                    width="71"
                    height="6"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="710.5"
                    y="400"
                    width="98.5"
                    height="20"
                    rx="10"
                    fill="#091E42"
                    fillOpacity=".08"
                />
                <path
                    d="M723.124 405.19c-3.35 0-5.646 2.318-5.646 5.702 0 3.493 2.235 5.708 5.762 5.708.862 0 1.689-.123 2.304-.335v-.862c-.431.199-1.354.328-2.29.328-2.926 0-4.813-1.879-4.813-4.798 0-2.844 1.921-4.881 4.594-4.881 2.735 0 4.608 1.688 4.608 4.156 0 1.682-.554 2.769-1.415 2.769-.493 0-.773-.281-.773-.759v-4.013h-1.032v.834h-.11c-.266-.595-.881-.964-1.599-.964-1.402 0-2.379 1.162-2.379 2.823 0 1.737.957 2.906 2.379 2.906.8 0 1.415-.39 1.709-1.087h.109c.082.67.704 1.148 1.504 1.148 1.572 0 2.57-1.415 2.57-3.643 0-2.967-2.249-5.032-5.482-5.032Zm-.239 3.829c.929 0 1.524.738 1.524 1.907s-.601 1.914-1.538 1.914c-.895 0-1.442-.725-1.442-1.914 0-1.197.54-1.907 1.456-1.907Z"
                    fill="#091E42"
                    fillOpacity=".48"
                />
                <rect
                    x="732"
                    y="407"
                    width="71"
                    height="6"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="817"
                    y="400"
                    width="98.5"
                    height="20"
                    rx="10"
                    fill="#091E42"
                    fillOpacity=".08"
                />
                <path
                    d="M829.624 405.19c-3.35 0-5.646 2.318-5.646 5.702 0 3.493 2.235 5.708 5.762 5.708.862 0 1.689-.123 2.304-.335v-.862c-.431.199-1.354.328-2.29.328-2.926 0-4.813-1.879-4.813-4.798 0-2.844 1.921-4.881 4.594-4.881 2.735 0 4.608 1.688 4.608 4.156 0 1.682-.554 2.769-1.415 2.769-.493 0-.773-.281-.773-.759v-4.013h-1.032v.834h-.11c-.266-.595-.881-.964-1.599-.964-1.402 0-2.379 1.162-2.379 2.823 0 1.737.957 2.906 2.379 2.906.8 0 1.415-.39 1.709-1.087h.109c.082.67.704 1.148 1.504 1.148 1.572 0 2.57-1.415 2.57-3.643 0-2.967-2.249-5.032-5.482-5.032Zm-.239 3.829c.929 0 1.524.738 1.524 1.907s-.601 1.914-1.538 1.914c-.895 0-1.442-.725-1.442-1.914 0-1.197.54-1.907 1.456-1.907Z"
                    fill="#091E42"
                    fillOpacity=".48"
                />
                <rect
                    x="838.5"
                    y="407"
                    width="71"
                    height="6"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="604"
                    y="452"
                    width="290"
                    height="20"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="604"
                    y="488"
                    width="730"
                    height="12"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="604"
                    y="516"
                    width="730"
                    height="12"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="604"
                    y="544"
                    width="343"
                    height="12"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="620"
                    y="582"
                    width="12"
                    height="12"
                    rx="2"
                    fill="#DFE1E6"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M622 582h8c1.105 0 2 .895 2 2v8c0 1.105-.895 2-2 2h-8c-1.105 0-2-.895-2-2v-8c0-1.105.895-2 2-2Zm1.382 5.069c.122.052.233.129.325.224l1.293 1.293 3.293-3.293c.092-.095.203-.172.325-.224.122-.052.253-.08.386-.081.132-.001.264.024.387.074.123.05.235.125.328.219.094.094.169.205.219.328.05.123.075.255.074.387-.001.133-.028.264-.081.386-.052.122-.128.233-.224.325l-4 4c-.188.187-.442.293-.707.293-.265 0-.519-.106-.707-.293l-2-2c-.096-.092-.172-.203-.224-.325-.053-.122-.08-.253-.081-.386-.001-.132.024-.264.074-.387.05-.123.125-.234.219-.328.093-.094.205-.169.328-.219.123-.05.255-.075.387-.074.133.001.264.029.386.081Z"
                    fill="#0052CC"
                />
                <rect
                    x="640"
                    y="585"
                    width="71"
                    height="6"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="620"
                    y="614"
                    width="12"
                    height="12"
                    rx="2"
                    fill="#DFE1E6"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M622 614h8c1.105 0 2 .895 2 2v8c0 1.105-.895 2-2 2h-8c-1.105 0-2-.895-2-2v-8c0-1.105.895-2 2-2Zm1.382 5.069c.122.052.233.129.325.224l1.293 1.293 3.293-3.293c.092-.095.203-.172.325-.224.122-.052.253-.08.386-.081.132-.001.264.024.387.074.123.05.235.125.328.219.094.094.169.205.219.328.05.123.075.255.074.387-.001.133-.028.264-.081.386-.052.122-.128.233-.224.325l-4 4c-.188.187-.442.293-.707.293-.265 0-.519-.106-.707-.293l-2-2c-.096-.092-.172-.203-.224-.325-.053-.122-.08-.253-.081-.386-.001-.132.024-.264.074-.387.05-.123.125-.234.219-.328.093-.094.205-.169.328-.219.123-.05.255-.075.387-.074.133.001.264.029.386.081Z"
                    fill="#0052CC"
                />
                <rect
                    x="640"
                    y="617"
                    width="71"
                    height="6"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="621"
                    y="647"
                    width="10"
                    height="10"
                    rx="1"
                    fill="#fff"
                />
                <rect
                    x="621"
                    y="647"
                    width="10"
                    height="10"
                    rx="1"
                    stroke="#7A869A"
                    strokeWidth="2"
                />
                <rect
                    x="640"
                    y="649"
                    width="71"
                    height="6"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="621"
                    y="679"
                    width="10"
                    height="10"
                    rx="1"
                    fill="#fff"
                />
                <rect
                    x="621"
                    y="679"
                    width="10"
                    height="10"
                    rx="1"
                    stroke="#7A869A"
                    strokeWidth="2"
                />
                <rect
                    x="640"
                    y="681"
                    width="71"
                    height="6"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="621"
                    y="711"
                    width="10"
                    height="10"
                    rx="1"
                    fill="#fff"
                />
                <rect
                    x="621"
                    y="711"
                    width="10"
                    height="10"
                    rx="1"
                    stroke="#7A869A"
                    strokeWidth="2"
                />
                <rect
                    x="640"
                    y="713"
                    width="71"
                    height="6"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="604"
                    y="748"
                    width="730"
                    height="12"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="604"
                    y="776"
                    width="730"
                    height="12"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="604"
                    y="804"
                    width="343"
                    height="12"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="604"
                    y="880"
                    width="290"
                    height="20"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="604"
                    y="916"
                    width="730"
                    height="12"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="604"
                    y="944"
                    width="730"
                    height="12"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="604"
                    y="972"
                    width="730"
                    height="12"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="604"
                    y="1000"
                    width="730"
                    height="12"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="604"
                    y="1028"
                    width="343"
                    height="12"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="272"
                    y="99"
                    width="100"
                    height="6"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="385"
                    y="99"
                    width="54"
                    height="6"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <path
                    d="m377.372 109.105 3.548-12.4409h-1.299l-3.541 12.4409h1.292Z"
                    fill="#6B778C"
                />
                <path fill="#F4F5F7" d="M0 58h240v1059H0z" />
                <g clipPath="url(#f)">
                    <path fill="#fff" fillOpacity=".01" d="M26 146h24v24H26z" />
                    <rect
                        x="22"
                        y="142"
                        width="32"
                        height="32"
                        rx="3"
                        fill="#091E42"
                        fillOpacity=".08"
                    />
                    <rect
                        x="66"
                        y="155"
                        width="71"
                        height="6"
                        rx="3"
                        fill="#091E42"
                        fillOpacity=".13"
                    />
                    <path fill="#fff" fillOpacity=".01" d="M26 190h24v24H26z" />
                    <rect
                        x="22"
                        y="186"
                        width="32"
                        height="32"
                        rx="3"
                        fill="#091E42"
                        fillOpacity=".08"
                    />
                    <rect
                        x="66"
                        y="199"
                        width="71"
                        height="6"
                        rx="3"
                        fill="#091E42"
                        fillOpacity=".13"
                    />
                    <path fill="#fff" fillOpacity=".01" d="M26 234h24v24H26z" />
                    <rect
                        x="22"
                        y="230"
                        width="32"
                        height="32"
                        rx="3"
                        fill="#091E42"
                        fillOpacity=".08"
                    />
                    <rect
                        x="66"
                        y="243"
                        width="71"
                        height="6"
                        rx="3"
                        fill="#091E42"
                        fillOpacity=".13"
                    />
                    <path fill="#fff" fillOpacity=".01" d="M26 278h24v24H26z" />
                    <rect
                        x="22"
                        y="274"
                        width="32"
                        height="32"
                        rx="3"
                        fill="#091E42"
                        fillOpacity=".08"
                    />
                    <rect
                        x="66"
                        y="287"
                        width="71"
                        height="6"
                        rx="3"
                        fill="#091E42"
                        fillOpacity=".13"
                    />
                    <path fill="#fff" fillOpacity=".01" d="M26 348h24v24H26z" />
                    <rect
                        x="22"
                        y="344"
                        width="32"
                        height="32"
                        rx="3"
                        fill="#091E42"
                        fillOpacity=".08"
                    />
                    <rect
                        x="66"
                        y="357"
                        width="71"
                        height="6"
                        rx="3"
                        fill="#091E42"
                        fillOpacity=".13"
                    />
                    <rect
                        x="16"
                        y="384"
                        width="208"
                        height="40"
                        rx="3"
                        fill="#091E42"
                        fillOpacity=".04"
                    />
                    <path fill="#fff" fillOpacity=".01" d="M40 392h24v24H40z" />
                    <circle
                        cx="52"
                        cy="404"
                        r="2"
                        fill="#091E42"
                        fillOpacity=".13"
                    />
                    <rect
                        x="72"
                        y="401"
                        width="125"
                        height="6"
                        rx="3"
                        fill="#091E42"
                        fillOpacity=".13"
                    />
                    <path fill="#fff" fillOpacity=".01" d="M40 436h24v24H40z" />
                    <circle
                        cx="52"
                        cy="448"
                        r="2"
                        fill="#091E42"
                        fillOpacity=".13"
                    />
                    <rect
                        x="72"
                        y="445"
                        width="125"
                        height="6"
                        rx="3"
                        fill="#091E42"
                        fillOpacity=".13"
                    />
                    <path fill="#fff" fillOpacity=".01" d="M40 480h24v24H40z" />
                    <circle
                        cx="52"
                        cy="492"
                        r="2"
                        fill="#091E42"
                        fillOpacity=".13"
                    />
                    <rect
                        x="72"
                        y="489"
                        width="125"
                        height="6"
                        rx="3"
                        fill="#091E42"
                        fillOpacity=".13"
                    />
                </g>
                <rect
                    x="18"
                    y="82"
                    width="40"
                    height="40"
                    rx="3"
                    fill="#DEEBFF"
                />
                <rect
                    x="66"
                    y="87"
                    width="97"
                    height="12"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <rect
                    x="66"
                    y="111"
                    width="141"
                    height="6"
                    rx="3"
                    fill="#091E42"
                    fillOpacity=".13"
                />
                <path fill="#fff" d="M1 0h1727v56H1z" />
                <path fill="#DFE1E6" d="M1 56h1727v2H1z" />
                <path fill="#fff" fillOpacity=".01" d="M1672 12h32v32h-32z" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1701.33 28.0001c0 7.3638-5.97 13.3333-13.33 13.3333s-13.33-5.9695-13.33-13.3333c0-7.3638 5.97-13.3334 13.33-13.3334s13.33 5.9696 13.33 13.3334Zm-9.33-4c0 2.2091-1.79 4-4 4s-4-1.7909-4-4c0-2.2092 1.79-4 4-4s4 1.7908 4 4Zm-4 14.6666c-2.42.0037-4.78-.822-6.67-2.34v-4.3266c0-1.4734 1.19-2.6667 2.67-2.6667h8c1.47 0 2.67 1.18 2.67 2.6667v4.3266c-1.83 1.464-4.15 2.34-6.67 2.34Z"
                    fill="#DFE1E6"
                />
                <g clipPath="url(#g)">
                    <rect
                        x="1341"
                        y="12"
                        width="238"
                        height="32"
                        rx="3"
                        fill="#F4F5F7"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1362 27c0 2.2091-1.79 4-4 4s-4-1.7909-4-4c0-2.2091 1.79-4 4-4s4 1.7909 4 4Zm-.52 4.8907C1360.5 32.5892 1359.3 33 1358 33c-3.31 0-6-2.6863-6-6s2.69-6 6-6 6 2.6863 6 6c0 1.2958-.41 2.4957-1.11 3.4765l2.82 2.8164c.39.3905.39 1.0237 0 1.4142-.39.3905-1.03.3905-1.42 0l-2.81-2.8164Z"
                        fill="#C1C7D0"
                    />
                    <path
                        fill="#fff"
                        fillOpacity=".01"
                        d="M1590 16h24v24h-24z"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1596.49 33.669c.18.1858.4.3332.64.4338.25.1005.51.1523.77.1523s.52-.0518.77-.1523c.24-.1006.46-.248.64-.4338l-2.82-2.83c-.19.1858-.34.4063-.44.6491-.1.2428-.15.5031-.15.7659 0 .2629.05.5231.15.7659.1.2428.25.4634.44.6491Zm4.89-12.191-.72.725c-.78.782-2.21 1.813-3.21 2.311l-3.02 1.509c-.49.248-.58.774-.18 1.171l8.55 8.556c.4.396.93.313 1.17-.188l1.51-3.016c.5-.988 1.53-2.42 2.32-3.206l.72-.726c.82-.8231 1.34-1.9055 1.45-3.0639.12-1.1583-.17-2.3213-.81-3.2921.11-.0861.2-.1934.26-.3152.07-.1217.1-.2554.12-.3928.01-.1373-.01-.2755-.06-.4059-.04-.1304-.11-.2504-.2-.3525-.1-.1021-.21-.1842-.33-.2412-.13-.0571-.26-.0878-.4-.0904-.14-.0026-.28.0231-.4.0754-.13.0522-.25.1301-.34.2286-.03.025-.05.049-.07.075-.83-.548-1.8-.8402-2.79-.84-.66-.0008-1.32.1294-1.93.383-.61.2537-1.17.6258-1.64 1.095v.001Z"
                        fill="#C1C7D0"
                    />
                    <path
                        fill="#fff"
                        fillOpacity=".01"
                        d="M1630 16h24v24h-24z"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1652 28c0 5.5228-4.48 10-10 10s-10-4.4772-10-10 4.48-10 10-10 10 4.4772 10 10Zm-7.17-4.84c.52.5195.89 1.1738 1.06 1.89.23.958.1 1.9681-.37 2.8356-.46.8675-1.24 1.5309-2.17 1.8624-.2.073-.35.255-.35.472v.782c0 .2657-.1.5206-.29.7085-.19.1879-.44.2935-.71.2935-.26 0-.52-.1056-.71-.2935-.18-.1879-.29-.4428-.29-.7085v-2.014c0-.263.11-.514.3-.6987.18-.1847.44-.2883.7-.2883h-.01c1.11 0 2.01-.898 2.01-2-.02-.5236-.23-1.0217-.61-1.3877-.37-.366-.87-.5708-1.4-.5706-.52.0003-1.03.2056-1.4.572-.37.3663-.59.8647-.6 1.3883 0 .551-.45.998-1 .998-.25-.0015-.49-.095-.67-.2622-.18-.1671-.29-.396-.31-.6418l-.01-.147c.02-2.504 2.32-4.436 4.93-3.842.72.1683 1.38.5325 1.9 1.052ZM1643 34c0 .5523-.45 1-1 1s-1-.4477-1-1 .45-1 1-1 1 .4477 1 1Z"
                        fill="#C1C7D0"
                    />
                </g>
                <g clipPath="url(#h)">
                    <g clipPath="url(#i)">
                        <path
                            fill="#fff"
                            fillOpacity=".01"
                            d="M53 16h137v24H53z"
                        />
                        <path
                            d="M89.175 34.4914c-.9683.6207-2.5014.8793-4.1151.8793-5.1103 0-7.9881-2.9483-7.9881-7.6811 0-4.5517 2.8778-7.7327 7.9612-7.7327 1.5062 0 3.0392.2845 4.142 1.0345v1.9914c-1.1028-.6725-2.34-1.0345-4.142-1.0345-3.6579 0-5.8095 2.3276-5.8095 5.7672 0 3.4397 2.2592 5.7155 5.944 5.7155 1.6406 0 2.9047-.362 4.0344-.9051v1.9655h-.0269ZM90.6542 29.4483c0-3.4138 2.071-5.8966 5.6213-5.8966 3.5234 0 5.5945 2.4828 5.5945 5.8966s-2.0711 5.9482-5.5945 5.9482c-3.5234-.0258-5.6213-2.5344-5.6213-5.9482Zm1.9903 0c0 2.1724 1.1028 4.112 3.6579 4.112 2.5013 0 3.604-1.9655 3.604-4.112 0-2.1466-1.0758-4.0862-3.604-4.0862-2.5551 0-3.6579 1.9138-3.6579 4.0862ZM114.296 35.1638h-2.044v-6.8793c0-2.0431-.861-2.9483-2.797-2.9483-1.883 0-3.201 1.2155-3.201 3.5172v6.3362h-2.044V23.8103h2.044v1.8621c.753-1.3448 2.152-2.0948 3.738-2.0948 2.717 0 4.277 1.8103 4.277 4.9396v6.6466h.027ZM123.037 23.7845v1.8103h-3.066v9.569h-1.99v-9.569h-1.91v-1.8103h1.91v-1.2414c0-2.1207 1.237-3.5431 3.765-3.5431.619 0 1.022.1034 1.372.181v1.8104c-.35-.0776-.807-.1035-1.291-.1035-1.264 0-1.883.6983-1.883 1.7328v1.1638h3.093ZM128.389 35.2155c-1.936 0-3.173-.8793-3.173-2.9741V19.0259h2.044v12.9827c0 1.0345.699 1.3966 1.586 1.3966.216 0 .35 0 .592-.0259v1.7586c-.188.0518-.538.0776-1.049.0776ZM131.159 23.7845h2.045v6.8793c0 2.0431.86 2.9483 2.797 2.9483 1.882 0 3.2-1.2155 3.2-3.5173v-6.3103h2.044v11.3793h-2.044v-1.8621c-.753 1.3449-2.151 2.0949-3.738 2.0949-2.717 0-4.277-1.8104-4.277-4.9397v-6.6724h-.027ZM149.96 35.3707c-4.438 0-6.374-2.4569-6.374-5.9483 0-3.4396 1.99-5.8965 5.594-5.8965 3.658 0 5.11 2.431 5.11 5.8965v.8793h-8.633c.295 1.9397 1.586 3.1811 4.384 3.1811 1.371 0 2.528-.2587 3.604-.6207v1.8103c-.996.5173-2.502.6983-3.685.6983Zm-4.357-6.7241h6.616c-.107-2.1207-1.103-3.3104-3.147-3.3104-2.151 0-3.254 1.319-3.469 3.3104ZM166.743 35.1638h-2.044v-6.8793c0-2.0431-.861-2.9483-2.797-2.9483-1.883 0-3.201 1.2155-3.201 3.5172v6.3362h-2.044V23.8103h2.044v1.8621c.753-1.3448 2.152-2.0948 3.739-2.0948 2.716 0 4.276 1.8103 4.276 4.9396v6.6466h.027ZM177.959 34.8534c-.7.3621-1.803.5173-2.878.5173-4.223 0-6.186-2.4569-6.186-5.9483 0-3.4396 1.963-5.8965 6.186-5.8965 1.075 0 1.882.1293 2.824.5431v1.8103c-.753-.3362-1.56-.5431-2.663-.5431-3.066 0-4.33 1.8621-4.33 4.0862 0 2.2242 1.291 4.0862 4.384 4.0862 1.21 0 1.963-.1552 2.689-.4138v1.7586h-.026ZM185.92 35.3707c-4.438 0-6.375-2.4569-6.375-5.9483 0-3.4396 1.991-5.8965 5.595-5.8965 3.658 0 5.11 2.431 5.11 5.8965v.8793h-8.634c.296 1.9397 1.587 3.1811 4.384 3.1811 1.372 0 2.529-.2587 3.604-.6207v1.8103c-.995.5173-2.474.6983-3.684.6983Zm-4.331-6.7241h6.617c-.108-2.1207-1.103-3.3104-3.147-3.3104-2.179 0-3.254 1.319-3.47 3.3104Z"
                            fill="#253858"
                        />
                        <path
                            d="M53.5918 32.425c-.1614.3-.3766.6273-.5379.9001-.1614.2454-.0807.5727.1882.7363l3.4965 2.1819c.269.1636.5917.0818.7531-.1909.1345-.2455.3228-.5455.511-.8728 1.3986-2.3182 2.7703-2.0455 5.2985-.8182l3.4696 1.6637c.269.1364.5917 0 .7262-.2727l1.6675-3.8183c.1076-.2727 0-.6-.2689-.7091-.7262-.3545-2.1786-1.0364-3.4965-1.6909-4.7337-2.291-8.7412-2.1546-11.8073 2.8909Z"
                            fill="url(#j)"
                        />
                        <path
                            d="M69.2721 23.7794c.1614-.3.3765-.6273.5379-.9.1614-.2455.0807-.5728-.1883-.7364l-3.4964-2.1818c-.269-.1637-.5918-.0819-.7531.1909-.1345.2454-.3228.5454-.5111.8727-1.3985 2.3182-2.7702 2.0455-5.2985.8182L56.12 20.1521c-.269-.1364-.5917 0-.7262.2727l-1.6676 3.8182c-.1076.2728 0 .6001.269.7091.7262.3546 2.1786 1.0364 3.4965 1.691 4.7067 2.3182 8.7142 2.1818 11.7804-2.8637Z"
                            fill="url(#k)"
                        />
                    </g>
                    <g clipPath="url(#l)">
                        <path
                            fill="#fff"
                            fillOpacity=".01"
                            d="M214 0h86v56h-86z"
                        />
                        <rect
                            x="221.5"
                            y="25"
                            width="71"
                            height="6"
                            rx="3"
                            fill="#091E42"
                            fillOpacity=".13"
                        />
                        <path
                            fill="#fff"
                            fillOpacity=".01"
                            d="M308 0h86v56h-86z"
                        />
                        <rect
                            x="312"
                            y="25"
                            width="64"
                            height="6"
                            rx="3"
                            fill="#091E42"
                            fillOpacity=".13"
                        />
                        <g opacity=".6" clipPath="url(#m)">
                            <path
                                fill="#fff"
                                fillOpacity=".01"
                                d="M382 18h8v20h-8z"
                            />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M382.292 26.2929c-.187.1889-.292.4439-.292.7095 0 .2657.105.5206.292.7095l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955c.187-.189.291-.4439.291-.7095 0-.2655-.104-.5204-.291-.7095-.092-.0931-.201-.1671-.322-.2176-.121-.0506-.25-.0766-.381-.0766s-.26.026-.381.0766c-.121.0505-.23.1245-.322.2176l-2.298 2.317-2.307-2.327c-.092-.0928-.202-.1665-.322-.2167-.121-.0503-.25-.0762-.381-.0762s-.26.0259-.381.0762c-.12.0502-.23.1239-.322.2167Z"
                                fill="#344563"
                            />
                        </g>
                        <path
                            fill="#fff"
                            fillOpacity=".01"
                            d="M402 0h86v56h-86z"
                        />
                        <rect
                            x="406"
                            y="25"
                            width="64"
                            height="6"
                            rx="3"
                            fill="#091E42"
                            fillOpacity=".13"
                        />
                        <g opacity=".6" clipPath="url(#n)">
                            <path
                                fill="#fff"
                                fillOpacity=".01"
                                d="M476 18h8v20h-8z"
                            />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M476.292 26.2929c-.187.1889-.292.4439-.292.7095 0 .2657.105.5206.292.7095l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955c.187-.189.291-.4439.291-.7095 0-.2655-.104-.5204-.291-.7095-.092-.0931-.201-.1671-.322-.2176-.121-.0506-.25-.0766-.381-.0766s-.26.026-.381.0766c-.121.0505-.23.1245-.322.2176l-2.298 2.317-2.307-2.327c-.092-.0928-.202-.1665-.322-.2167-.121-.0503-.25-.0762-.381-.0762s-.26.0259-.381.0762c-.12.0502-.23.1239-.322.2167Z"
                                fill="#344563"
                            />
                        </g>
                        <path
                            fill="#fff"
                            fillOpacity=".01"
                            d="M496 0h86v56h-86z"
                        />
                        <rect
                            x="500"
                            y="25"
                            width="64"
                            height="6"
                            rx="3"
                            fill="#091E42"
                            fillOpacity=".13"
                        />
                        <g opacity=".6" clipPath="url(#o)">
                            <path
                                fill="#fff"
                                fillOpacity=".01"
                                d="M570 18h8v20h-8z"
                            />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M570.292 26.2929c-.187.1889-.292.4439-.292.7095 0 .2657.105.5206.292.7095l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955c.187-.189.291-.4439.291-.7095 0-.2655-.104-.5204-.291-.7095-.092-.0931-.201-.1671-.322-.2176-.121-.0506-.25-.0766-.381-.0766s-.26.026-.381.0766c-.121.0505-.23.1245-.322.2176l-2.298 2.317-2.307-2.327c-.092-.0928-.202-.1665-.322-.2167-.121-.0503-.25-.0762-.381-.0762s-.26.0259-.381.0762c-.12.0502-.23.1239-.322.2167Z"
                                fill="#344563"
                            />
                        </g>
                        <path
                            fill="#fff"
                            fillOpacity=".01"
                            d="M590 0h86v56h-86z"
                        />
                        <rect
                            x="597.5"
                            y="25"
                            width="71"
                            height="6"
                            rx="3"
                            fill="#091E42"
                            fillOpacity=".13"
                        />
                        <rect
                            x="692"
                            y="12"
                            width="61"
                            height="32"
                            rx="3"
                            fill="#B3D4FF"
                        />
                        <rect
                            x="700"
                            y="25"
                            width="44"
                            height="6"
                            rx="3"
                            fill="#091E42"
                            fillOpacity=".13"
                        />
                    </g>
                </g>
                <path fill="#fff" fillOpacity=".01" d="M19 16h24v24H19z" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M23 21.01c0-.559.443-1.01 1.01-1.01h1.98c.559 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Z"
                    fill="#A5ADBA"
                />
                <path fill="#091E42" fillOpacity=".54" d="M0 0h1728v1117H0z" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M0 0h1728v1117H0z" />
                </clipPath>
                <clipPath id="b">
                    <path
                        fill="#fff"
                        transform="translate(1456 86)"
                        d="M0 0h232v32H0z"
                    />
                </clipPath>
                <clipPath id="c">
                    <path
                        fill="#fff"
                        transform="translate(1456 86)"
                        d="M0 0h128v32H0z"
                    />
                </clipPath>
                <clipPath id="d">
                    <path
                        fill="#fff"
                        transform="translate(648 206)"
                        d="M0 0h192v6H0z"
                    />
                </clipPath>
                <clipPath id="f">
                    <path
                        fill="#fff"
                        transform="translate(16 138)"
                        d="M0 0h208v374H0z"
                    />
                </clipPath>
                <clipPath id="g">
                    <path
                        fill="#fff"
                        transform="translate(1340 11)"
                        d="M0 0h314v34H0z"
                    />
                </clipPath>
                <clipPath id="h">
                    <path
                        fill="#fff"
                        transform="translate(53)"
                        d="M0 0h700v56H0z"
                    />
                </clipPath>
                <clipPath id="i">
                    <path
                        fill="#fff"
                        transform="translate(53 16)"
                        d="M0 0h137v24H0z"
                    />
                </clipPath>
                <clipPath id="l">
                    <path
                        fill="#fff"
                        transform="translate(210)"
                        d="M0 0h543v56H0z"
                    />
                </clipPath>
                <clipPath id="m">
                    <path
                        fill="#fff"
                        transform="translate(382 18)"
                        d="M0 0h8v20H0z"
                    />
                </clipPath>
                <clipPath id="n">
                    <path
                        fill="#fff"
                        transform="translate(476 18)"
                        d="M0 0h8v20H0z"
                    />
                </clipPath>
                <clipPath id="o">
                    <path
                        fill="#fff"
                        transform="translate(570 18)"
                        d="M0 0h8v20H0z"
                    />
                </clipPath>
                <linearGradient
                    id="j"
                    x1="69.0523"
                    y1="37.3758"
                    x2="58.4012"
                    y2="31.34"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#0052CC" />
                    <stop offset=".9182" stopColor="#2380FB" />
                    <stop offset="1" stopColor="#2684FF" />
                </linearGradient>
                <linearGradient
                    id="k"
                    x1="53.8258"
                    y1="18.8262"
                    x2="64.4769"
                    y2="24.862"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#0052CC" />
                    <stop offset=".9182" stopColor="#2380FB" />
                    <stop offset="1" stopColor="#2684FF" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default LightConfluenceBackground;
